let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("btg2k")).then(() => parcelRequire('8reN2'));